<template>
  <label v-if="label && label.text" :for="forName" class="grp-label-main">
    {{ label.text }}
  </label>
</template>

<script>
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'BaseLabel',
  props: {
    forName: { type: String, default: '' },
    label: { type: Object, required: false, default: () => null },
  },
});
</script>

<style lang="scss" scoped>
.grp-label-main {
  display: flex;
  align-items: center;
  margin-bottom: 0.5rem;
  letter-spacing: -0.005em;
  color: $white;
}
</style>
